import { lazy } from "react";
import { Outlet } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import ScrollToTop from "@/components/feature/ScrollToTop";

const HomePage = lazy(() => import("@/pages/home/page"));
const ClassesPage = lazy(() => import("@/pages/classes/page"));
const CoachesPage = lazy(() => import("@/pages/coaches/page"));
const CoachDetailPage = lazy(() => import("@/pages/coaches/detail"));
const NotFoundPage = lazy(() => import("@/pages/NotFound"));

function Layout() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
}

export const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/classes",
        element: <ClassesPage />,
      },
      {
        path: "/coaches",
        element: <CoachesPage />,
      },
      {
        path: "/coaches/:id",
        element: <CoachDetailPage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];
